<mat-card *ngIf="aggregates" style="padding: 0px;width:100%">
  <mat-toolbar style="font-weight:bold;width:100%"><h3 style="width:120px;margin-left:10px">
    {{ 'seguimentHorari.titol' | translate }}
  </h3>
  </mat-toolbar>
  <mat-card-content>
    <mat-list style="float:left;clear:both;width:100%">
      <mat-list-item *ngIf="aggregates.total">
        {{ 'seguimentHorari.resum' | translate:{ recorded: (getNumber(aggregates.total) | number:'1.0-0'), total: (getNumber(totalHores) | number:'1.0-0') } }}
      </mat-list-item>
      <mat-list-item *ngIf="getHoresPendents()">
      {{ 'seguimentHorari.pendents' | translate:{ pending: (getHoresPendents() | number:'1.0-0') } }}
      </mat-list-item>
    </mat-list>
  </mat-card-content>
</mat-card>
